export default function truncateString(string, length = 350) {
  if (!string) return;
  return string.length > length ? `${string.slice(0, length)}...` : string;
}
